<div class="login-by-user-password-container">
  <section>
    <app-loading *ngIf="isLoading" />
    <img src="assets/images/svg/logo.svg" alt="Logo" width="229" height="50" />
    <form *ngIf="!loginHint" [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form">
      <div class="left w-full">
        <div class="left description">
          {{ 'Please enter your username.' | translate }}
        </div>
        <mat-form-field class="mat-form-field" appearance="outline">
          <mat-label>{{ 'Username' | translate }}</mat-label>
          <input id="username" formControlName="username" matInput required placeholder="{{ 'Username' | translate }}" />
        </mat-form-field>
        <div class="left description">
          {{ 'Please enter your password.' | translate }}
        </div>
        <mat-form-field class="mat-form-field" appearance="outline">
          <mat-label>{{ 'Password' | translate }}</mat-label>
          <input
            id="password"
            formControlName="password"
            matInput
            [type]="showPassword() ? 'text' : 'password'"
            required
            placeholder="{{ 'New password' | translate }}"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="clickEvent($event)"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="showPassword()"
            class="btn-toggle-password"
            tabindex="0"
          >
            <mat-icon class="material-icons-outlined">{{ showPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </mat-form-field>
        <div class="forgot-password">
          <app-button [label]="'Forgot password?' | translate" variant="tertiary" (click)="handleClickForgotPassword()" />
        </div>
      </div>
      <app-button [label]="'button.Next' | translate" type="submit" />
    </form>
    <app-migrated-user-prompt
      *ngIf="loginHint"
      [loginHint]="loginHint"
      [promptContent]="promptContent"
      [title]="promptTitle"
      [type]="type"
      [goPreStep]="goPreStep"
    ></app-migrated-user-prompt>
  </section>
</div>
